import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

export class NewPasswordController {
   static $inject = ['$state', 'session', 'toast'];

   constructor(private $state:uir.StateService, private session, private toast) { }

   identity:string;
   generating = false;

   generate() {
      if (!this.identity) {
         this.toast.error()
            .message('Please enter the username or email address associated with your account')
            .send();

         return;
      }

      this.generating = true;

      this.session.forgotPassword(this.identity.trim()).then(() => {
         this.toast.success()
            .title('Success')
            .message('We have sent a reset link to your email, be sure to use it within the next 15 minutes')
            .send();
         this.$state.go('login');
      }).catch((err: any) => {
         const errorMessage = err?.data?.message || 'Something went wrong. Please try again later.';
         this.toast.error()
            .message(errorMessage)
            .send();
      }).finally(() => this.generating = false);
   }
}

ng.module('e360').component('newPasswordRequest', {
   controller: NewPasswordController,
   templateUrl: require('./new-password-request.html')
});
